import Flex, { DIRECTION_CLASS, GAP_CLASS } from "components/Flex";
import { object, shape } from "prop-types";

import styles from "./DonutTooltip.module.scss";

const refType = shape({ current: object });

const DonutTooltip = ({ tooltipRef, titleRef, bodyRef }) => (
  <Flex
    ref={tooltipRef}
    aria-hidden="true"
    className={styles.donutTooltip}
    direction={DIRECTION_CLASS.column}
    gap={GAP_CLASS.GAP_050}
  >
    <span ref={titleRef} className={styles.donutTooltip__title} />
    <span ref={bodyRef} className={styles.donutTooltip__body} />
  </Flex>
);

DonutTooltip.propTypes = {
  tooltipRef: refType.isRequired,
  titleRef: refType.isRequired,
  bodyRef: refType.isRequired,
};

export default DonutTooltip;
